import React from 'react'

import Flex from '@ui-pc/Flex'
import Rate from '@ui-pc/RateStars'
import { Type } from '@utils/tool'

import { ctx } from '../../utils'

export const ReviewsStat = () => {
  const [state] = ctx.useState()
  const { score, reviewNum } = state

  const number = Type.number(score)

  const peopleNum = Type.number(reviewNum)

  return (
    <Flex span="auto" className="reviews-stat" justify="center">
      <span className="rate-number">{number}</span>
      <Flex inlineFlex span="auto" justify="center" direction="column">
        <Rate className="rate" value={number} />
        <span className="reviews">{peopleNum} Reviews</span>
      </Flex>
    </Flex>
  )
}
